import { Field, useFormikContext } from 'formik'
import cn from 'classnames'
import { isEmpty } from 'lodash'

import InputFullTime from 'components/InputFullTime'

const BusinessEndTime = ({ id, showValidationErrors }) => {
  const { values, setFieldValue } = useFormikContext()

  const handleChangeTime = (time) => {
    const timeToUpdate = isEmpty(time?.fullTime)
      ? null
      : time?.fullTime

    setFieldValue('businessEndTime', timeToUpdate)
  }

  return (
    <section>
      <div
        className={cn('content-wrapper -flags-wrapper -block', {
          '-error': showValidationErrors,
        })}
      >
        <h3 id={id} className="header-title">
          Business End Time
        </h3>
        <p className="description">Time in 24-hour format</p>
        <div className="content-wrapper ">
          <Field
            component={InputFullTime}
            name="businessEndTime"
            handleChange={handleChangeTime}
            time={values?.businessEndTime ?? ''}
            showValidationErrors={showValidationErrors}
            shorter={false}
            isActive={true}
            isSetFieldValue={true}
            isLabel={true}
            dataCy="input-fullTime"
          />
        </div>
      </div>
    </section>
  )
}

export default BusinessEndTime
